import { Box, styled } from '@mui/material'

export const PageContainer = styled(Box)(() => ({
    minHeight: '70dvh'
}))